import React, { useState } from "react";
import {
  Flex,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  AvatarGroup,
  Avatar,
  Button,
} from "@chakra-ui/react";
import { activityResponseTypes, activityTypes } from "@constants/activities";
import {
  PollResults,
  QuizResults,
  SendResultsUI,
} from "@components/ActivityTypes";
import AttendeeDetailView from "./AttendeeDetailView";

const activityResultObject = {
  [activityTypes.quiz]: QuizResults,
  [activityTypes.poll]: PollResults,
  [activityTypes.share]: SendResultsUI,
};

const sharedStyles = {
  fontWeight: "400",
  fontSize: "12px",
  color: "dark.300",
};

const ActivityResultAccordion = ({
  options,
  type,
  response,
  settings,
  title,
  content,
  link,
  numberOfParticipants,
  participants = [],
  activityId,
  isAccordionOpen,
  toggleAccordion,
  isAgendaLive = false,
  activity,
}) => {
  const [showingAttendeeDetail, setShowingAttendeeDetail] = useState(false);

  const totalResponse = response.length;
  const responseParticipants = response.map(
    (singleResponse) => singleResponse.user
  );

  const ResultComponent = activityResultObject[type];
  const handleOpenAccordion = isAccordionOpen ? 0 : -1;

  const handleAttendeeDetailClick = () => {
    setShowingAttendeeDetail(true);
  };

  const handleBackToSummary = () => {
    setShowingAttendeeDetail(false);
  };

  return (
    <Accordion allowToggle={true} index={handleOpenAccordion}>
      <AccordionItem border={0}>
        {({ isExpanded }) => (
          <>
            <Flex justifyContent="space-between" alignItems="center">
              <Flex alignItems="center">
                {responseParticipants.length ? (
                  <AvatarGroup size="xs" max={2} mr={2} fontSize="12px">
                    {responseParticipants.map((participant) => (
                      <Avatar
                        key={participant.userId}
                        name={`${participant.firstName} ${participant.lastName}`}
                        src={participant.avatar}
                      />
                    ))}
                  </AvatarGroup>
                ) : null}

                <Text
                  {...sharedStyles}
                  data-testid={`activity-response-count${
                    activityId ? `-${activityId}` : ""
                  }`}
                >
                  {totalResponse}{" "}
                  {totalResponse === 1
                    ? activityResponseTypes[type].singular
                    : activityResponseTypes[type].plural}
                </Text>
              </Flex>
              <AccordionButton
                w="inherit"
                p="0"
                bg="transparent"
                _hover={{ bg: "transparent" }}
                _active={{ bg: "transparent" }}
                onClick={() => toggleAccordion()}
                data-testid={`activity-details-accordion-button${
                  activityId ? `-${activityId}` : ""
                }`}
                {...sharedStyles}
              >
                {`${isExpanded ? "Hide" : "Detail"}`} <AccordionIcon />
              </AccordionButton>
            </Flex>
            <AccordionPanel p="10px 0">
              {showingAttendeeDetail ? (
                <AttendeeDetailView
                  response={response}
                  activityType={type}
                  options={options}
                  participants={participants}
                  activityId={activityId}
                  onBackToSummary={handleBackToSummary}
                  activity={activity || { options, link }}
                />
              ) : (
                <ResultComponent
                  options={options}
                  response={response}
                  title={title}
                  content={content}
                  link={link}
                  settings={settings}
                  numberOfParticipants={numberOfParticipants}
                />
              )}
              {!showingAttendeeDetail && (response.length > 0 || isAgendaLive) && (
                <Button
                  variant="transparent"
                  w="100%"
                  mt="10px"
                  p="0"
                  onClick={handleAttendeeDetailClick}
                  data-testid={`attendee-detail-button${
                    activityId ? `-${activityId}` : ""
                  }`}
                >
                  <Text color="#6533EE" fontSize="12px">
                    Attendee Detail
                  </Text>
                </Button>
              )}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default ActivityResultAccordion;
